"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.array.from.js");

require("core-js/modules/es6.weak-map.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find.js");

require("core-js/modules/es6.regexp.match.js");

require("core-js/modules/es6.regexp.constructor.js");

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.array.filter.js");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Input = require("../../Input");

require("./TagFilterTypeahead.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TagFilterTypeahead = function TagFilterTypeahead(props) {
  var modelBase = props.modelBase,
      searchInputModel = props.searchInputModel,
      filteredInputModel = props.filteredInputModel,
      tagFilterModel = props.tagFilterModel,
      customClass = props.customClass,
      pre = props.pre,
      change = props.change,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? 'Search' : _props$placeholder,
      _props$data = props.data,
      data = _props$data === void 0 ? [] : _props$data,
      _props$onSelect = props.onSelect,
      onSelect = _props$onSelect === void 0 ? function () {} : _props$onSelect,
      _props$tags = props.tags,
      tags = _props$tags === void 0 ? [] : _props$tags,
      typeaheadRef = props.typeaheadRef;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      filterTag = _useState2[0],
      setFilterTag = _useState2[1];

  var prevMatchedTag = (0, _react.useRef)('');
  var validators = {
    filterTag: function filterTag(val) {
      if (val === undefined) return true;
      var matchedTag = tags.find(function (tag) {
        return "".concat(val).match(new RegExp("^(".concat(tag, ":).*")));
      }) || '';

      if (prevMatchedTag.current !== matchedTag) {
        setFilterTag(matchedTag);
        change("".concat(modelBase).concat(tagFilterModel), matchedTag);
        prevMatchedTag.current = matchedTag;
      }

      var searchWithoutTag = val.replace(new RegExp("^".concat(matchedTag, ":\\s?")), '');
      change("".concat(modelBase).concat(filteredInputModel), searchWithoutTag);
      return true;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tag-filter-typeahead"
  }, tags.filter(function (tag) {
    return filterTag === tag;
  }).map(function (tag, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "filter-tag-".concat(i),
      className: "selected-filter-tag"
    }, tag, ":");
  }), /*#__PURE__*/_react.default.createElement(_Input.Typeahead, {
    placeholder: placeholder,
    customClass: customClass,
    modelBase: modelBase,
    data: data,
    pre: pre,
    onSelect: onSelect,
    validators: validators,
    model: searchInputModel,
    ref: typeaheadRef,
    type: "text"
  }));
};

var _default = (0, _reactRedux.connect)(null, {
  change: _Input.formActions.change
})(TagFilterTypeahead);

exports.default = _default;